<div class="toast-wrapper">
  <div class="toast-icon">
    <span class="dx-icon-plus"></span>
  </div>
  <div class="toast-message">
    ERROR: KENAN TEST AAAAAAAAAAAAAAAAAAAAAAAAA
  </div>
</div>
